export const PENDIENTE_DE_INI_DE = 1;
export const OTROS_OBLIGADOS = 2;
export const ANULACION_ERROR_SU = 3;
export const BAJA_PROV_POR_OFICI = 4;
export const NUM_INTERNO_IDENTIF = 5;
export const BAJA_DEFINITIVA = 6;
export const INHABILITADO_VENT_UN = 7;
export const BAJA_MULT_INSCR_Y_O = 8;
export const ANULACION_ACTO_ILI = 9;
export const BAJA_DE_OFICIO = 10;
export const BAJA_PROVISIONAL = 11;
export const ACTIVO = 12;
export const SUSPENSION_TEMPORAL = 13;
export const ANUL_PROVI_ACTO_ILI = 14;